import { lazy } from 'react';

// Lazy load all system pages for performance
export const SystemDashboard = lazy(() => import('./SystemDashboard'));
export const SystemSettings = lazy(() => import('./SystemSettings'));
export const SystemPricing = lazy(() => import('./SystemPricing'));
export const SystemTenants = lazy(() => import('./SystemTenants'));
export const SystemUsers = lazy(() => import('./SystemUsers'));
export const SystemSupport = lazy(() => import('./SystemSupport'));
export const SystemAudit = lazy(() => import('./SystemAudit'));
